import { FC, useEffect } from 'react';
import { HStack, VStack, Text, Switch, Divider } from '@chakra-ui/react';

import { updateTemplateFeature } from '../form-slice';
import { useAppDispatch } from '../../../hooks';
import { useGetAllFormFeaturesQuery } from '../../../services';
import { Form } from '../../../models';

export const FormFeatures: FC<{
  features: Form['features'];
}> = ({ features }) => {
  const { data } = useGetAllFormFeaturesQuery();
  const dispatch = useAppDispatch();
  useEffect(() => {
    if (data?.data.length) {
      data?.data.forEach(feature => {
        dispatch(
          updateTemplateFeature({
            featureId: feature.id,
            isEnabled: true,
          })
        );
      });
    }
  }, [data,features]);
  return (
    <VStack align="start" gap="4">
      {data?.data.map(({ id, name, description, canBeDisabled }, index) => (
        <VStack key={id} align="start" color="custom_blue.1" w="full">
          <HStack w="full">
            <Text flexBasis="50%" fontWeight="semibold" fontSize="lg">
              {name}
            </Text>

            <Switch
              flexBasis="50%"
              isChecked={
                features.find(feature => feature.featureTypeId === id)
                  ?.isEnabled
              }
              isDisabled={true}
              colorScheme="orange"
              onChange={e => {
                dispatch(
                  updateTemplateFeature({
                    featureId: id,
                    isEnabled: e.target.checked,
                  })
                );
              }}
            />
          </HStack>

          <Text fontSize="sm">{description}</Text>

          {data?.data.length - 1 > index && <Divider borderWidth="1px" />}
        </VStack>
      ))}
    </VStack>
  );
};
